var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vast-service-order-now-main-button__container"},[_c('OBtn',{class:[
      'vast-service-order-now-main-button',
      { 'margin-top': _vm.couponInputIsShown }
    ],attrs:{"height":"58px","disabled":!_vm.isButtonActive},on:{"click":function($event){return _vm.createOrder()}}},[(_vm.creatingLoading)?_c('div',[_c('OLoader'),_vm._v(" "+_vm._s(_vm.locale.createOrderButtonLoadingText)+" ")],1):_c('div',[_vm._v(" "+_vm._s(_vm.locale.createOrderButtonText)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }